// extracted by mini-css-extract-plugin
export default {"subheader":"Title_subheader__ceW1Z","subheaderMain":"Title_subheaderMain__cF+we","subheaderSecondary":"Title_subheaderSecondary__u2wbd"};